import { defaultTheme } from 'gd-design-library';

export const menu = {
  ...defaultTheme.menu,
  wrapper: {
    default: {
      ...defaultTheme.menu.wrapper.default,
      display: 'flex',
      alignItems: 'center',
      textTransform: 'uppercase',
      fontSize: '14px',
      letterSpacing: '0.64px',
      cursor: 'pointer'
    }
  },
  content: {
    ...defaultTheme.menu.content,
    default: {
      ...defaultTheme.menu.content.default,
      zIndex: 1100,
      paddingTop: 4,
      paddingBottom: 4,
      boxShadow: '0px 5px 16px 4px rgba(0, 0, 0, 0.1)'
    }
  }
};
